import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Avatar, Box, Container, useMediaQuery, useTheme } from '@material-ui/core'
import DesktopHeaderWrap from '../../components/DeskTopHeaderWrap'
import { useStyles } from './MyAccount.style'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

// import ForumIcon from '@material-ui/icons/Forum'
import Card from '../../components/common/Card'
import ChangePasswordProfile from './pages/changePassword/ChangePasswordProfile'
import MyProfile from './pages/myProfile/MyProfile'
import MyAddress from './pages/myAddress/MyAddress'
// import MyOrder from './pages/myOrder/MyOrder'
// import MyWishlist from './pages/myWishlist/MyWishlist'
import AddAddress from './pages/myAddress/AddAddress'
import UpdateAddress from './pages/myAddress/UpdateAddress'
// import DialogAlert from '../../components/common/DialogAlert'
import { t } from 'i18next'
import i18n from '../language/localization'
import { getBadgeCart } from '../../api/badge'
import { useAuth } from '../../hooks/useAuth'
import { useQuery } from '../../hooks/useQuery'
import { ArrowCircleLeft2, Lock } from 'iconsax-react'
import { AddressIcon, ProfileMenuIcon } from 'components/Icons'
import RestrictMobile from 'components/RestrictMobile'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  }
}

const MyAccount = props => {
  const history = useHistory()
  const searchParams = useQuery()
  const paramTab = searchParams.get('tab')
  const { token } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const datauser = JSON.parse(localStorage.getItem('userdata'))

  const { active, webThemeColor } = props
  const classes = useStyles()
  const [navigate, setNavigate] = useState('')
  // const [open, setOpen] = useState(true)
  const [categoriesData, setCategoriesData] = useState([])
  const [TotalCartItems, setItems] = useState(0)
  const [value, setValue] = React.useState(
    active === 'changeAddress' ? 1 : active === 'successOrderPay' ? 2 : 0
  )
  const usersdata = JSON.parse(localStorage.getItem('userdata'))
  const logout = () => {
    localStorage.clear()
    window.location.href = '/'
  }
  // const close = () => {
  //   setOpen(false)
  // }
  // const openModal = () => {
  //   setOpen(true)
  // }
  const handleChange = (event, newValue) => {
    setValue(newValue)
    history.push(`/my-profile?tab=${newValue}`)
  }

  useEffect(() => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    if (paramTab) {
      setValue(Number(paramTab))
    }
  }, [paramTab])

  const MenuItem = props => {
    return (
      <div className='menuItem'>
        {props.icon}
        <h4 className='menuTitle'>{props.title}</h4>
      </div>
    )
  }

  const themeColor = JSON.parse(localStorage.getItem('themeColor'))

  // console.log("navigate___ ", navigate);
  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
    if (localStorage.getItem('landing_page')) {
      setCategoriesData(JSON.parse(localStorage.getItem('landing_page'))['product_categories'])
    }
    getBadge()
  }, [])

  const getBadge = async () => {
    if (token) {
      const cartDataResult = await getBadgeCart()
      if (cartDataResult?.success) {
        setItems(cartDataResult.data)
      }
    }
  }

  if (isMobile && datauser.role === 'requestor') {
    return <RestrictMobile />
  }

  return (
    <div className={classes.body}>
      <DesktopHeaderWrap
        // clickTab={() => setInlineCategory(false)}
        themeColor={'rgb(231, 0, 116)'}
        categoriesData={categoriesData}
        cartNumber={TotalCartItems}
      />

      <Container>
        <Box className={classes.root_MyAccount}>
          <h5 className={classes.pageTitle}></h5>
          <div className={classes.leftTabs_style}>
            <Card className={classes.cardStyle_LeftSide + ' ' + classes.left_Sidebar}>
              <div className={classes.user_profile_name} onClick={() => setValue(0)}>
                <Avatar
                  src={
                    usersdata
                      ? process.env.REACT_APP_FILE_BASE_URL + '/' + usersdata.profile_picture
                      : null
                  }
                  style={{ marginRight: 10 }}
                />

                <div className='media-body'>
                  <h3 className='profileName'>{usersdata ? usersdata.name : null}</h3>
                  <p className='font12 font-weight-normal text-white poppins mb-0'>
                    <span style={{ textTransform: 'capitalize' }}>{usersdata?.role}</span>
                  </p>
                </div>
              </div>

              <Tabs
                orientation='vertical'
                variant='scrollable'
                value={value}
                onChange={handleChange}
                aria-label='Vertical tabs example'
                className={classes.tabs + ' ' + ' ' + classes.Leftmenu}
              >
                <Tab
                  label={<MenuItem title='Profile' icon={<ProfileMenuIcon size={20} />} />}
                  {...a11yProps(0)}
                />

                <Tab
                  label={<MenuItem title='Address' icon={<AddressIcon size={20} />} />}
                  {...a11yProps(1)}
                />

                <Tab
                  label={<MenuItem title='Password' icon={<Lock size={20} />} />}
                  {...a11yProps(5)}
                />
                <Tab
                  label={<MenuItem title={t('logout2')} icon={<ArrowCircleLeft2 size={20} />} />}
                  onClick={logout}
                  // {...a11yProps(6)}
                />
              </Tabs>
            </Card>
            <Card className={classes.right_Sidebar} style={{ width: 'calc(100% - 228px)' }}>
              <TabPanel value={value} index={0}>
                <MyProfile webThemeColor={webThemeColor} themeColor={themeColor} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                {navigate == 'addAddress' ? (
                  <AddAddress
                    setNavigate={setNavigate}
                    webThemeColor={webThemeColor}
                    themeColor={themeColor}
                  />
                ) : navigate == 'myAddress' ? (
                  <MyAddress
                    setNavigate={setNavigate}
                    webThemeColor={webThemeColor}
                    themeColor={themeColor}
                  />
                ) : navigate == 'updateAddress' ? (
                  <UpdateAddress
                    setNavigate={setNavigate}
                    webThemeColor={webThemeColor}
                    themeColor={themeColor}
                  />
                ) : (
                  <MyAddress
                    setNavigate={setNavigate}
                    webThemeColor={webThemeColor}
                    themeColor={themeColor}
                  />
                )}
              </TabPanel>
              {/* <TabPanel value={value} index={3}>
                <MyWishlist valueTab={value} />
              </TabPanel> */}
              {/* <TabPanel value={value} index={4}>
                {t('content_will_coming_soon')}
              </TabPanel> */}
              <TabPanel value={value} index={2}>
                <ChangePasswordProfile webThemeColor={webThemeColor} themeColor={themeColor} />
              </TabPanel>
              {/* <TabPanel value={value} index={4}>
                <DialogAlert open={open} close={close} yesno='true' no={close} ok={logout}>
                  {t('ask_logout')}
                </DialogAlert>
              </TabPanel> */}
            </Card>
          </div>
        </Box>
      </Container>
    </div>
  )
}

export default MyAccount
